<template>
    <div class="signInForm">
        <div class="pt-5 mx-3 pb-1">
            <div class="d-flex justify-content-center align-items-center">
                <img border="0" :src="imgPath" width="120" height="120" alt="">
            </div>
            <h2 class="text-center py-3 bg-single comment-color">メールアドレス再設定</h2>
            <div class="bg-single">
                <div class="mx-sm-auto signContents">
                    <p class="mb-4 comment-color">
                        入力したメールアドレスにメールを送信しました。<br>
                        手順に従って会員情報変更完了を行なってください。<br>
                        メールが届かない場合は下記までお問い合わせください。<br>
                        {{ this.info_mail }}
                    </p>
                </div>
            </div>
            <div class="text-center mb-4" v-if="btnUse">
                <button
                    type="button"
                    class="confirmbutton"
                    @click="tologinPage()"
                >
                    {{ btnName }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { MEMBER_LOG_OUT } from "../../constants/signout";

export default {
    data () {
        return {
            info_mail: process.env.MIX_SUPPORT_MAILADDRESS,
            btnUse: false,
            btnName: '',
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png"
        };
    },
    created () {
        this.initialize();
    },
    mounted: function () {
        this.$nextTick(function () {
            // 画面読み込み終了後ログアウト処理をする
            this.logOut();
        })
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
            if (process.env.MIX_APP_URL) {
                this.btnUse = false;
                this.btnName = 'アプリを起動';
            } else {
                this.btnUse = true;
                this.btnName = 'ログインページに戻る';
            }
        },
        /** ----------------------------------------------
         * ログインページに戻るボタン処理
         * ---------------------------------------------- */
        tologinPage: function (){
            if (process.env.MIX_APP_URL) {
                window.location.href = process.env.MIX_APP_URL;
            } else {
                // ログイン画面へ遷移
                this.$router.push({ path: '/' });
            }
        },
        /** ----------------------------------------------
         * ログアウト処理
         * ---------------------------------------------- */
        logOut: function () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
    }
}
</script>
<style scoped>
.container {
    color: #ffffff;
}
@media screen and (min-width: 576px) {
    .signContents {
        width: 420px;
    }
}
.signInForm {
    height: 100vh;
}
</style>
